/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InitializationDTO } from '../model/models';
import { TenantDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface InitializeRequestParams {
    initializationDTO: InitializationDTO;
}

export class ClsInitializeRequestParams {
    initializationDTO: InitializationDTO = undefined;
}


export interface AdminInitializeApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Initialize new customer data
     * Create tenant, organization and first user
* @param requestParameters
     */
    initialize(requestParameters: InitializeRequestParams, extraHttpRequestParams?: any): Observable<TenantDTO>;

}
